"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"
import ConditionalNav from "@/components/student/ConditionalNav"
import { useAuth } from "@/lib/auth"

const PUBLIC_PATHS = ["/student/login"]

export default function StudentLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  const { user, token, loading } = useAuth()
  const isPublic = PUBLIC_PATHS.some((p) => pathname.startsWith(p))

  useEffect(() => {
    if (loading || isPublic) return
    if (!token || user?.role !== "student") {
      window.location.assign("/student/login")
    }
  }, [loading, token, user?.role, isPublic])

  if (isPublic) {
    return (
      <div className="min-h-screen bg-bg">
        <main>{children}</main>
      </div>
    )
  }

  if (loading || !token || user?.role !== "student") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg">
        <p className="text-text-muted">載入中...</p>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-bg">
      <main className="pb-24">{children}</main>
      <ConditionalNav />
    </div>
  )
}
